import { Button, styled } from "@mui/material";
import { APP_COLOR } from "../../../theme";

export const styles = {
  trackControls: {
    display: "flex",
    flexDirection: "column",
    // width: "20vw",
    height: "31vh",
    backgroundColor: "#222222",
    padding: "10px",
    marginRight: "5px",
  } as const,
  instrumentType: {
    width: "90%",
    height: "40px",
    color: "white",
    backgroundColor: "black",
    marginBottom: "10px",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiSvgIcon-root": {
      color: "gray",
    },
  } as const,
  instrumentListItem: {
    backgroundColor: "black",
    color: "white",
    "&:hover": {
      backgroundColor: "#bbbbb",
      color: "black",
    },
    "&.Mui-selected": {
      backgroundColor: "#bbbbb",
      color: "black",
    },
  } as const,
  nameField: {
    width: "90%",
    backgroundColor: "black",
    marginBottom: "10px",
    marginUp: "0px",
    borderRadius: "5px",
    input: {
      height: "10px",
      color: "white",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
    },
  } as const,
  icons: {
    height: 25,
    width: 25,
    minWidth: 25,
    // margin: "2px 0",
    color: "black",
    backgroundColor: APP_COLOR,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
  } as const,
  label: { color: "#bbbbbb", margin: "0px" } as const,
};

interface TrackButtonProps {
  clicked?: boolean;
}

export const TrackControlButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "clicked",
})<TrackButtonProps>(({ clicked }) => ({
  maxWidth: "35px",
  maxHeight: "35px",
  minWidth: "35px",
  minHeight: "35px",
  backgroundColor: clicked ? "#28B6CB" : "gray",
  "&:hover": { backgroundColor: clicked ? "#28B6CB" : "gray" },
}));
